import React from "react";

const FilterSection = ({ selectedMonth, onMonthChange }) => {
  const months = [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
  ];

  return (
    <div className="d-flex flex-column gap-3 mb-5">
      <div className="d-flex justify-content-between align-items-center">
        {/* Month Selector */}
        <select
          className="form-select w-auto text-light rounded-pill py-1 bg-transparent border-2 border-light shadow-none"
          value={selectedMonth}
          onChange={(e) => onMonthChange(Number(e.target.value))}
        >
          {months.map((month, index) => (
            <option key={index} value={index}>
              {month}
            </option>
          ))}
        </select>

        {/* Legend */}
        <div className="d-flex align-items-center gap-3 small">
          <span className="d-flex align-items-center">
            <div
              className="rounded-circle bg-white me-1"
              style={{ width: "8px", height: "8px" }}
            ></div>
            Income
          </span>
          <span className="d-flex align-items-center">
            <div
              className="rounded-circle bg-warning me-1"
              style={{ width: "8px", height: "8px" }}
            ></div>
            Expense
          </span>
        </div>
      </div>
    </div>
  );
};

export default FilterSection;
